import {Suspense} from "react";
import {Helmet} from "react-helmet-async";

import androidLogo from "@/assets/images/download-android.svg";
import iosLogo from "@/assets/images/download-ios.svg";
import {useCurrentUserContext} from "@/components/context/hooks.ts";
import ContentContainer from "@/components/layout/ContentContainer.tsx";
import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";

export const MobileAppsPage = () => {
  const {brand} = useCurrentUserContext();
  return (
    <ContentContainer title="Mobile Apps">
      <Helmet>
        <title>Mobile Apps</title>
      </Helmet>
      <Suspense>
        <UpErrorBoundary>
          <h2>Monitor your uptime, from anywhere</h2>
          <div className="lead mb-4">
            Download our iOS or Android apps to manage and monitor all your checks from wherever you are.
          </div>
          <div className="mb-4">
            <a target="_blank" href={brand.android ?? ""} className="me-4">
              <img src={androidLogo} height="95" alt="Android" />
            </a>
            <a target="_blank" href={brand.ios ?? ""}>
              <img src={iosLogo} height="95" alt="iOS" />
            </a>
          </div>
          <div className="small text-muted">* Note: An {brand.name} subscription plan is required.</div>
        </UpErrorBoundary>
      </Suspense>
    </ContentContainer>
  );
};
